import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";
import itzyImage1 from "@/assets/itzy-group-photo-1.webp";
import itzyImage2 from "@/assets/itzy-study-session-2.jpg";

const StudyWithItzy = () => {
  return (
    <KpopStudyPageTemplate
      groupName="ITZY"
      groupNameDisplay="ITZY"
      fandomName="MIDZYs"
      seoTitle="Study With ITZY - MIDZY Study Rooms"
      seoDescription="Study with ITZY fans worldwide. Join MIDZYs in virtual study rooms with ITZY playlists, themed spaces, and 24/7 study sessions for focused productivity."
      seoKeywords="study with itzy, itzy study room, midzy study, kpop study room, itzy playlist study"
      canonicalUrl="/study-with-itzy/"
      heroDescription="Join MIDZYs worldwide who study with ITZY's energetic vibes. Stay motivated with their message of self-confidence and achieve your goals together."
      aboutContent={
        <>
          <p>
            <a href="https://itzy.jype.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ITZY</a> is a South Korean girl group formed by <a href="https://www.jype.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">JYP Entertainment</a>, known for their empowering messages and energetic performances. The group consists of five members: Yeji, Lia, Ryujin, Chaeryeong, and Yuna.
          </p>
          <p>
            MIDZYs around the world find motivation in ITZY's positive energy. Follow them on <a href="https://www.instagram.com/itzyofficial/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/ITZYofficial" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@ITZY" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          As part of the growing trend of "study with K-Pop," ITZY fans have created spaces where they can combine their passion for ITZY with productive study sessions. These sessions often involve playing <a href="https://open.spotify.com/artist/2KC9Qb60EaY0kW4eH68vr3" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ITZY's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "ITZY Study Playlists", desc: "Study with curated ITZY playlists featuring their empowering songs that keep you motivated and energized." },
        { title: "Connect with MIDZYs", desc: "Join study rooms with fellow MIDZYs from around the world who share your passion for ITZY." },
        { title: "Themed Study Rooms", desc: "Create or join ITZY-themed study rooms with custom backgrounds inspired by their iconic concepts." },
        { title: "24/7 Study Sessions", desc: "Access ITZY study rooms anytime, anywhere. Stay productive with their empowering energy." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of ITZY and other K-Pop groups can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://itzy.jype.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@ITZY" },
        { name: "Instagram", url: "https://www.instagram.com/itzyofficial/" },
        { name: "X (Twitter)", url: "https://twitter.com/ITZYofficial" },
        { name: "Spotify", url: "https://open.spotify.com/artist/2KC9Qb60EaY0kW4eH68vr3" },
        { name: "TikTok", url: "https://www.tiktok.com/@itzy.all.in.us" },
      ]}
      youtubeVideos={[
        { id: "fE2h3lGlOsk", title: "ITZY - WANNABE M/V" },
        { id: "pNfTK39k55U", title: "ITZY - DALLA DALLA M/V" },
        { id: "F0B7HDiY-10", title: "ITZY - SNEAKERS M/V" },
        { id: "MjCZfZfucEc", title: "ITZY - LOCO M/V" },
        { id: "d9IxdwEFk1c", title: "ITZY - CAKE M/V" },
        { id: "Hbb5GPxXF1w", title: "ITZY - In the Morning M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@ITZY"
      youtubeChannelName="ITZY"
      image1={itzyImage1}
      image2={itzyImage2}
    />
  );
};

export default StudyWithItzy;
